// ------------------------------------
// props 輸入需求 : 
// props.data : object : { data: array }            ( sleep Qualities )
// ------------------------------------


import React from 'react'
import { useTranslation } from 'react-i18next';
const SETable =(props)=>{
    const [t] = useTranslation()
    let data = props.data
    function translate_Sec_to_Hr(sec){
        let _sec = parseInt(sec)
        let _hours = parseInt(_sec/3600)%60
        let _min = parseInt(_sec/60)%60
        return (sec!=="None")? `${_hours}${t("GLOBAL.UNIT.HOURS")}${_min}${t("GLOBAL.UNIT.MINUTE")}`:"-"
    }

    function translate_data_format(date){
        let _date = new Date(date)
        return (date!=="None")? `${_date.getMonth()+1} / ${_date.getDate()}`:"-"
    }

    // function translate_time_format(date){
    //     let _date = new Date(date)
    //     return (date!=="None")? `${_date.getMonth()+1}/${_date.getDate()} ${_date.getHours()}:${addZero(_date.getMinutes())}:${addZero(_date.getSeconds())}`:"-"
    // }

    function calculateAlert(_rec, _avg, _func){
        let _percentage = Math.round(100*(parseInt(_rec)-parseInt(_avg))/parseInt(_avg))
        if(_percentage>10){return <div className='red_font bold'>{_func(_rec)}</div>}
        else if(_percentage<-10){return <div className='red_fon bold'>{_func(_rec)}</div>}
        else{ return _func(_rec) }
    }
    // function addZero(time){ return (time/10>1)? time:"0"+time }
    
    return(
        data.SE===undefined? <div className='font-l fx-ccc'>-</div>:
        <>
            <div className='frame-title _1 bgTitle fx-d-r font-m'>
                <div className='col-2 border fx-ccc'></div>
                <div className='col-2 border fx-ccc'>{t('GLOBAL.DATE')}</div>
                <div className='col-2 border fx-ccc'>{t('DASHBOARD.SLEEP_QUALITY')}</div>
                <div className='col-2 border fx-ccc'>{t("HISTORY_RECORD.INBED_TIME")}</div>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.TOTAL_SLEEPING_TIME')}</div>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.SLEEP_LATENCY')}</div>
            </div>
            <div className='frame-title _1 fx-d-r font-m'>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.RECORD')}</div>
                <div className='col-2 border fx-ccc'>{translate_data_format(data.created_at)}</div>
                <div className='col-2 border fx-ccc'>{(data.SE!=="None")?data.SE:"-"}</div>
                <div className='col-2 border fx-ccc'>{calculateAlert(data.total_time, data.average_total_time, translate_Sec_to_Hr)}</div>
                <div className='col-2 border fx-ccc'>{calculateAlert(data.total_sleep_time, data.average_total_sleep_time, translate_Sec_to_Hr)}</div>
                <div className='col-2 border fx-ccc'>{calculateAlert(data.total_sleep_latency, data.average_total_sleep_latency, translate_Sec_to_Hr)}</div>
            </div>
            <div className='frame-title _1 fx-d-r font-m'>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.MEAN')}</div>
                <div className='col-2 border fx-ccc'>{}</div>
                <div className='col-2 border fx-ccc'>{(data.average_SE!=="None")?data.average_SE:"-"}</div>
                <div className='col-2 border fx-ccc'>{translate_Sec_to_Hr(data.average_total_time)}</div>
                <div className='col-2 border fx-ccc'>{translate_Sec_to_Hr(data.average_total_sleep_time)}</div>
                <div className='col-2 border fx-ccc'>{translate_Sec_to_Hr(data.average_total_sleep_latency)}</div>
            </div>
            <div className='frame-title _1 bgTitle fx-d-r font-m'>
                <div className='col-2 border fx-ccc'></div>
                <div className='col-2 border fx-ccc'>{t("HISTORY_RECORD.ROLL")}</div>
                <div className='col-2 border fx-ccc'>{t("HISTORY_RECORD.NIBTIMES")}</div>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.NIB')}</div>
                <div className='col-2 border fx-ccc'>{t("HISTORY_RECORD.MAX_NIB")}</div>
                <div className='col-2 border fx-ccc'></div>
            </div>
            <div className='frame-title _1 fx-d-r font-m'>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.RECORD')}</div>
                <div className='col-2 border fx-ccc'>{(data.turn_over_num!=="None")? calculateAlert(data.turn_over_num, data.average_turn_over_num, a=>a):"-"}</div>
                <div className='col-2 border fx-ccc'>{(data.NIB_num!=="None")? calculateAlert(data.NIB_num, data.average_NIB_num, a=>a):"-"}</div>
                <div className='col-2 border fx-ccc'>{calculateAlert(data.total_NIB_time, data.average_total_NIB_time, translate_Sec_to_Hr)}</div>
                <div className='col-2 border fx-ccc'>{calculateAlert(data.NIB_max_time, data.average_NIB_max_time, translate_Sec_to_Hr)}</div>
                <div className='col-2 border fx-ccc'></div>
            </div>
            <div className='frame-title _1 fx-d-r font-m'>
                <div className='col-2 border fx-ccc'>{t('HISTORY_RECORD.MEAN')}</div>
                <div className='col-2 border fx-ccc'>{(data.average_turn_over_num!=="None")? data.average_turn_over_num:"-"}</div>
                <div className='col-2 border fx-ccc'>{(data.average_NIB_num!=="None")? data.average_NIB_num:"-"}</div>
                <div className='col-2 border fx-ccc'>{translate_Sec_to_Hr(data.average_total_NIB_time)}</div>
                <div className='col-2 border fx-ccc'>{translate_Sec_to_Hr(data.average_NIB_max_time)}</div>
                <div className='col-2 border fx-ccc'></div>
            </div>
        </>
    );	

}
export default SETable;